import BookingHelper from '@/store/booking_stores/BookingHelper';

export default () => {
  return {
    namespaced: true,
    state: {
      attachments: [],
      attachmentsSelectState: false,
      fileInputReset: false,
      errors: {attachments: {name: 'attachmentsError', errors: []}}
    },
    getters: {
      attachments(state) {
        return state.attachments.filter((attachment) => {
          return attachment.deleted !== undefined ? !attachment.deleted : true;
        });
      },
      attachmentsCount(state, getters) {
        return getters.attachments.length;
      },
      fileType(state) {
        if (state.attachments.length) {
          const maxSize = Math.max(...state.attachments.map((att) => att?.file?.size));
          const maxSizedAttachment = state.attachments.find((att) => att?.file?.size === maxSize) || {};
          return maxSizedAttachment.file?.type || 'unknown';
        }
        return '';
      },
    },
    mutations: {
      ...BookingHelper().mutations,
      setAttachments(state, {files}) {
        if (files && files.length) {
          // Remove Not Allowed Files types [Folders, exe]
          const notAllowedList = ['', 'application/x-msdownload'];
          const validFiles = Array.from(files);
          for (let i = 0; i < files.length; i += 1) {
            const isInvalidFile = notAllowedList.includes(files[i]?.type);
            const isDuplicateFile = !!state.attachments?.find((file) => file.name == files[i]?.name);
            if (isDuplicateFile || isInvalidFile) {
              // if validFiles and splice index are equal splice will be skipped
              if (validFiles.length > i) validFiles.splice(i, 1);
              else validFiles.pop();
            }
          }

          for (let i = 0; i < validFiles.length; i += 1) {
            state.attachments.push({
              file: validFiles[i],
              name: validFiles[i].name,
              error: false
            });
          }
          state.fileInputReset = !state.fileInputReset;
        }
      },
      setAttachmentPassword(state, {index, password}) {
        state.attachments[index].file_password = password;
      },
      setAttachmentsList(state, attachments) {
        state.attachments = attachments;
      },
      setAttachmentsErrors(state, {data, context}) {
        Object.keys(data).forEach((index) => {
          if (data[+index].file.includes('This file is too big')) {
            state.attachments[+index].error = context.$gettext('This file is too big.');
          } else {
            state.attachments[+index].error = false;
          }
        });
      },
      setAttachmentsSelectState(state, value) {
        state.attachmentsSelectState = value;
      },
      deleteAttachment(state, {index, id}) {
        if (id) {
          state.attachments = state.attachments.map((attachment) => {
            return attachment.id == id
              ? {
                ...attachment,
                deleted: true
              }
              : attachment;
          });
        } else {
          state.attachments.splice(index, 1);
        }
      },
      deleteAllAttachments(state) {
        state.attachments = state.attachments.map((attachment) => ({
          ...attachment,
          deleted: true
        }));
      },
      clearStore(state) {
        state.attachments = [];
        state.attachmentsSelectState = false;
        state.fileInputReset = false;
        state.errors.attachments.errors = [];
      }
    }
  };
};
